import React, { useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faFileImport, faStore } from "@fortawesome/free-solid-svg-icons";
import AssetsExplorerView, { AssetsExplorerViewHandle } from "./explorer/AssetsExplorerView";
import PublishWizard from "../marketplace/PublishWizard";
import { AssetTableItem } from "../../types/types";

const AssetsPage: React.FC = () => {
  const explorerRef = useRef<AssetsExplorerViewHandle>(null);
  const [isSelectionMode, setIsSelectionMode] = useState(false);
  const [isWizardOpen, setIsWizardOpen] = useState(false);
  const [selectedAssets, setSelectedAssets] = useState<AssetTableItem[]>([]);

  const handleToggleSelection = () => {
    setIsSelectionMode(!isSelectionMode);
    explorerRef.current?.toggleSelectionMode();
  };

  const handleNextPublish = () => {
    const assets = explorerRef.current?.getSelectedAssets() || [];
    if (assets.length === 0) {
      alert("Please select at least one asset to publish.");
      return;
    }
    setSelectedAssets(assets);
    setIsWizardOpen(true);
  };

  return (
    <div className="bg-zinc-950 text-white flex flex-col" style={{ height: "calc(100vh - 56px)" }}>
      {/* ── Page header ── */}
      <div className="flex items-center justify-between px-4 py-3 bg-zinc-900 border-b border-zinc-800 flex-shrink-0">
        <h1 className="text-lg font-light tracking-wide">Compendium</h1>

        <div className="flex items-center gap-2">
          {isSelectionMode ? (
            <div className="flex items-center gap-2">
              <span className="text-xs text-amber-400 bg-amber-400/10 px-2 py-1 rounded border border-amber-400/20 mr-2">
                Selection Mode
              </span>
              <button
                onClick={handleToggleSelection}
                className="px-3 py-1.5 text-sm border border-zinc-700 text-zinc-300 rounded hover:bg-zinc-800 transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={handleNextPublish}
                className="px-3 py-1.5 text-sm bg-blue-600 text-white font-medium rounded hover:bg-blue-500 transition-colors"
              >
                Next: Publish
              </button>
            </div>
          ) : (
            <>
              <button
                onClick={handleToggleSelection}
                className="flex items-center gap-2 px-3 py-1.5 text-sm border border-zinc-700 text-amber-400 font-medium rounded hover:bg-zinc-800 transition-colors"
              >
                <FontAwesomeIcon icon={faStore} className="text-xs" />
                Publish to Marketplace
              </button>
              <button
                onClick={() => explorerRef.current?.openAddRoot()}
                className="flex items-center gap-2 px-3 py-1.5 text-sm bg-amber-400 text-zinc-950 font-medium rounded hover:bg-amber-300 transition-colors"
              >
                <FontAwesomeIcon icon={faPlus} className="text-xs" />
                Add Entry
              </button>
              <button
                onClick={() => explorerRef.current?.openImport()}
                className="flex items-center gap-2 px-3 py-1.5 text-sm border border-zinc-700 text-zinc-300 rounded hover:bg-zinc-800 hover:text-white transition-colors"
              >
                <FontAwesomeIcon icon={faFileImport} className="text-xs" />
                Import Entries
              </button>
            </>
          )}
        </div>
      </div>

      {/* ── Explorer View ── */}
      <div className="flex-1 overflow-hidden">
        <AssetsExplorerView ref={explorerRef} />
      </div>

      {/* ── Publish Wizard ── */}
      {isWizardOpen && (
        <PublishWizard
          selectedAssets={selectedAssets}
          onClose={() => setIsWizardOpen(false)}
          onSuccess={() => {
            setIsWizardOpen(false);
            handleToggleSelection();
          }}
        />
      )}
    </div>
  );
};

export default AssetsPage;
